import { render, staticRenderFns } from "./m-editSelectionChild.vue?vue&type=template&id=1a72ba6e&"
import script from "./m-editSelectionChild.vue?vue&type=script&lang=js&"
export * from "./m-editSelectionChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports